class BrandsPage {
  constructor(element) {
    this.element = element;
    this.searchInput = null;
    this.navButtons = [];
    this.brandCards = [];
    this.brandSections = [];
    this.currentFilter = 'all';
    this.searchTerm = '';
    
    this.init();
  }
  
  init() {
    this.searchInput = this.element.querySelector('.brands-page__search-input');
    this.navButtons = Array.from(this.element.querySelectorAll('.brands-page__nav-button'));
    this.brandCards = Array.from(this.element.querySelectorAll('.brands-page__card'));
    this.brandSections = Array.from(this.element.querySelectorAll('.brands-page__section'));
    
    if (this.searchInput) {
      this.searchInput.addEventListener('input', this.handleSearch.bind(this));
    }
    
    this.navButtons.forEach(button => {
      button.addEventListener('click', this.handleNavClick.bind(this));
    });
    
    const urlParams = new URLSearchParams(window.location.search);
    const searchParam = urlParams.get('search');
    const letterParam = urlParams.get('letter');
    
    if (searchParam) {
      this.searchInput.value = searchParam;
      this.searchTerm = searchParam.toLowerCase();
      this.filterBrands();
    }
    
    if (letterParam) {
      const button = this.navButtons.find(btn => btn.dataset.letter === letterParam.toLowerCase());
      if (button) {
        this.handleNavClick({ currentTarget: button });
      }
    }
  }
  
  handleSearch(event) {
    this.searchTerm = event.target.value.toLowerCase().trim();
    this.updateURL();
    this.filterBrands();
    
    if (this.searchTerm) {
      this.setActiveNavButton(null);
    } else if (this.currentFilter === 'all') {
      this.showAllBrands();
    } else {
      this.filterByLetter(this.currentFilter);
    }
  }
  
  handleNavClick(event) {
    const button = event.currentTarget;
    const letter = button.dataset.letter;
    
    this.currentFilter = letter;
    this.searchTerm = '';
    
    if (this.searchInput) {
      this.searchInput.value = '';
    }
    
    this.setActiveNavButton(button);
    this.filterByLetter(letter);
    this.updateURL();
  }
  
  setActiveNavButton(activeButton) {
    this.navButtons.forEach(btn => {
      if (btn === activeButton) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }
  
  filterByLetter(letter) {
    this.brandSections.forEach(section => {
      const sectionLetter = section.dataset.letter;
      
      if (letter === 'all') {
        section.classList.remove('hidden');
        this.showCardsInSection(section, true);
      } else if (letter === 'number') {
        if (sectionLetter === 'number') {
          section.classList.remove('hidden');
          this.showCardsInSection(section, true);
        } else {
          section.classList.add('hidden');
        }
      } else {
        if (sectionLetter === letter) {
          section.classList.remove('hidden');
          this.showCardsInSection(section, true);
        } else {
          section.classList.add('hidden');
        }
      }
    });
    
    this.hideNoResults();
  }
  
  filterBrands() {
    if (!this.searchTerm) {
      if (this.currentFilter === 'all') {
        this.showAllBrands();
      } else {
        this.filterByLetter(this.currentFilter);
      }
      return;
    }
    
    let hasResults = false;
    
    this.brandSections.forEach(section => {
      const cards = section.querySelectorAll('.brands-page__card');
      let sectionHasVisibleCards = false;
      
      cards.forEach(card => {
        const brandName = card.dataset.brandName || '';
        
        if (brandName.includes(this.searchTerm)) {
          card.classList.remove('hidden');
          sectionHasVisibleCards = true;
          hasResults = true;
        } else {
          card.classList.add('hidden');
        }
      });
      
      if (sectionHasVisibleCards) {
        section.classList.remove('hidden');
      } else {
        section.classList.add('hidden');
      }
    });
    
    if (hasResults) {
      this.hideNoResults();
    } else {
      this.showNoResults();
    }
  }
  
  showAllBrands() {
    this.brandSections.forEach(section => {
      section.classList.remove('hidden');
      this.showCardsInSection(section, true);
    });
    this.hideNoResults();
  }
  
  showCardsInSection(section, show) {
    const cards = section.querySelectorAll('.brands-page__card');
    cards.forEach(card => {
      if (show) {
        card.classList.remove('hidden');
      } else {
        card.classList.add('hidden');
      }
    });
  }
  
  showNoResults() {
    const noResults = this.element.querySelector('.brands-page__no-results-search');
    if (noResults) {
      noResults.style.display = 'block';
    }
  }
  
  hideNoResults() {
    const noResults = this.element.querySelector('.brands-page__no-results-search');
    if (noResults) {
      noResults.style.display = 'none';
    }
  }
  
  updateURL() {
    const url = new URL(window.location);
    
    if (this.searchTerm) {
      url.searchParams.set('search', this.searchTerm);
      url.searchParams.delete('letter');
    } else if (this.currentFilter !== 'all') {
      url.searchParams.set('letter', this.currentFilter);
      url.searchParams.delete('search');
    } else {
      url.searchParams.delete('search');
      url.searchParams.delete('letter');
    }
    
    window.history.replaceState({}, '', url);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    const brandsPageElement = document.querySelector('.brands-page');
    if (brandsPageElement && !brandsPageElement.brandsPageInstance) {
      brandsPageElement.brandsPageInstance = new BrandsPage(brandsPageElement);
    }
  });
} else {
  const brandsPageElement = document.querySelector('.brands-page');
  if (brandsPageElement && !brandsPageElement.brandsPageInstance) {
    brandsPageElement.brandsPageInstance = new BrandsPage(brandsPageElement);
  }
}

